import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Excited Particles",
  date: new Date(2024, 2, 31),
  img: "/img/lawnmower.jpeg",
  tracks: [
    {
      title: "Merry-Go-Round",
      src: "/songs/2024-03-31/merry_go_round.mp3",
      duration: 694.632,
    },
    {
      title: "Bucking Bronco",
      src: "/songs/2024-03-31/bucking_bronco.mp3",
      duration: 625.584,
    },
    {
      title: "Dreams Of A Dancer",
      src: "/songs/2024-03-31/dreams_of_a_dancer.mp3",
      duration: 673.104,
    },
    {
      title: "Hand In Hand",
      src: "/songs/2024-03-31/hand_in_hand.mp3",
      duration: 412.344,
    },
    {
      title: "Drifting Off",
      src: "/songs/2024-03-31/drifting_off.mp3",
      duration: 391.368,
    },
    {
      title: "Unearthed Cicadas",
      src: "/songs/2024-03-31/unearthed_cicadas.mp3",
      duration: 686.184,
    },
    {
      title: "Slow-Moving Freight Train",
      src: "/songs/2024-03-31/slow_moving_freight_train.mp3",
      duration: 515.352,
    },
    {
      title: "Crispy Chicken Nuggets",
      src: "/songs/2024-03-31/crispy_chicken_nuggets.mp3",
      duration: 1508.976,
    },
    {
      title: "Wallflower",
      src: "/songs/2024-03-31/wallflower.mp3",
      duration: 525.96,
    },
    {
      title: "Ballroom Janitor",
      src: "/songs/2024-03-31/ballroom_janitor.mp3",
      duration: 623.52,
    },
    {
      title: "Sly Fox",
      src: "/songs/2024-03-31/sly_fox.mp3",
      duration: 1040.28,
    },
    {
      title: "Waffles With Syrup",
      src: "/songs/2024-03-31/waffles_with_syrup.mp3",
      duration: 499.224,
    },
  ],
};
export default album;
